import AdminPage from "../components/Admin";
import LogReport from "../components/Comingsoon";
import SlogWeld from "../components/LogData/SlogWeld";
import HotPassTable from "../components/PqrReportData/HotPassTable";
import RenamingPassTable from "../components/RenamingPass";
import WeldParameterMain from "../components/data360LiveWeldParametersView/WeldParameterMain";
import D360LiveViews from "../components/data360_live_views";
import HotPassTabledata360live from "../components/data360live_PRQ_Report/HotPassTable";
import PqrReportTableLive from "../components/data360live_PRQ_Report/PqrReportTable";
import TlogLiveData from "../components/data360live_tlog/tlog_data";
import PqrReportTable from "../components/subcomponents/PqrReportTable";
import TlogData from "../components/subcomponents/TlogData";
import { HomeLayout } from "../layout";
import HomePage from "../pages/data360Live_home";
import Home from "../pages/home-page";

export default [
  {
    path: "/",
    exact: true,
    layout: HomeLayout,
    component: Home,
  },
  {
    path: "/data360-home",
    layout: HomeLayout,
    component: Home,
  },
  {
    path: "/data360-home/pqr-report",
    layout: HomeLayout,
    component: Home,
  },
  {
    path: "/log-report",
    layout: HomeLayout,
    component: LogReport,
  },
  {
    path: "/slog-weld/:weld_number",
    layout: HomeLayout,
    component: SlogWeld,
  },
  {
    path: "/data360-live-views/:weld_number",
    layout: HomeLayout,
    component: D360LiveViews,
  },
  {
    path: "/tlog-data",
    layout: HomeLayout,
    component: TlogData,
  },
  {
    path: "/tlog-data/:passName",
    layout: HomeLayout,
    component: TlogData,
  },
  {
    path: "/data360-live-tlog-data",
    layout: HomeLayout,
    component: TlogLiveData,
  },
  {
    path: "/data360-live-tlog-data/:passName",
    layout: HomeLayout,
    component: TlogLiveData,
  },
  {
    path: "/pqr-table-data/:weld_numbers",
    layout: HomeLayout,
    component: PqrReportTable,
  },
  {
    path: "/data360-live-pqr-table-data/:weld_numbers",
    layout: HomeLayout,
    component: PqrReportTableLive,
  },
  {
    path: "/wps-limit-table",
    layout: HomeLayout,
    component: HotPassTable,
  },
  {
    path: "/data360-live-wps-limit-table",
    layout: HomeLayout,
    component: HotPassTabledata360live,
  },
  {
    path: "/admin",
    layout: HomeLayout,
    component: AdminPage,
  },
  {
    path: "/data360Live",
    layout: HomeLayout,
    component: HomePage,
  },
  {
    path: "/data360Live/pqr-report",
    layout: HomeLayout,
    component: HomePage,
  },
  {
    path: "/weld-parameter-view",
    layout: HomeLayout,
    component: WeldParameterMain,
  },
  {
    path: "/renaming-pass",
    layout: HomeLayout,
    component: RenamingPassTable,
  },
];
